module.exports = __webpack_public_path__ + "bundles/EventSubmission/assets/images/testimonial-picture1-db1182d8ef3723a146284dcb38bfade9.png";


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/assets/images/testimonial-picture1.png
// module id = 1609
// module chunks = 0